$(function () {
  if (window.Theme) return;

  const style = getComputedStyle(document.body);
  let theme = {};
  const baseColorNames = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark'];
  const grays = [...Array(8).keys()].map(k => `gray-${((k + 1) * 100).toString()}`);
  const colors = [...baseColorNames, ...grays]
  colors.forEach(name => {
    theme[name] = style.getPropertyValue(`--${name}`);
  })
  window.Theme = theme;
});
